import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '@core';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';

@Component({
  selector: 'app-search-acte-optique',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './search-acte-optique.component.html',
  styleUrl: './search-acte-optique.component.scss',
})
export class SearchActeOptiqueComponent implements OnChanges {
  @Output() itemActeSelected = new EventEmitter<any>();
  @Input() cancelItemSelected: any;
  @Input() disabledItem: boolean = false;

  searchText = '';
  canDisplay = false;
  listItem: any[] = [];
  itemSelected: any = {};
  itemsGarantie: any[] = [];
  itemsPerPage = 15;
  user: any = {};

  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
    private utilities: UtilitiesService,
  ) {
    this.user = this.authService.currentUserValue;
    this.getItemsGarantie();
  }

  getItemsGarantie() {
    this.restClient.post('garantie/getByCriteria', { index: 0, size: 1000, data: {} }).subscribe(
      (res: any) => {
        if (res && !res['hasError'] && res['items']) {
          this.itemsGarantie = res.items;
        }
      },
    );
  }

  getItems() {
    this.canDisplay = true;
    if (!this.itemsGarantie?.length) return;
    const garantie_id = this.itemsGarantie.find((g: any) => g.codification === 'OPT')?.id;
    if (!garantie_id) return;

    this.restClient.post('acte/getByCriteria', {
      index: 0,
      size: this.itemsPerPage,
      search_key: this.searchText,
      data: { garantie_id },
    }).subscribe((res: any) => {
      if (res && res['items']) {
        this.listItem = res['items'].map((li: any) => {
          return { ...li, styled: this.highlight(li.libelle) };
        });
      } else {
        this.listItem = [];
      }
    });
  }

  highlight(libelle: string): string {
    if (!this.searchText) return libelle;
    const regex = new RegExp(`(${this.searchText})`, 'gi');
    return libelle.replace(regex, '<strong>$1</strong>');
  }

  selectItem(item: any) {
    this.itemSelected = { ...item };
    this.searchText = item.libelle;
    this.canDisplay = false;
    this.itemActeSelected.emit(this.itemSelected);
  }

  reinitValue() {
    this.itemSelected = {};
    this.searchText = '';
    this.canDisplay = false;
    this.listItem = [];
    this.itemActeSelected.emit(null);
  }

  getMedicationStatusClass(item: any): string {
    if (item.is_exclu) return 'excluded';
    if (item.is_entente_prealable) return 'prior-agreement';
    return 'available';
  }

  onScroll(event: any) {
    const el = event.target;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50) {
      this.itemsPerPage += 10;
      this.getItems();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['cancelItemSelected']?.currentValue) {
      this.reinitValue();
    }
  }
}
